/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * Internationalization constants for Widget Personal Account
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Misha Kokoulin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Julia Ignatieva
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.0.1
 */
import IWidgetPersonalAccountTranslation from '../../../types/pages/dashboard/widgetPersonalAccount';

const initTranslationWidgetPersonalAccount: IWidgetPersonalAccountTranslation = {
    error: '',
    outflowType: {
        CREDIT: '',
        PREPAID: '',
    },
    success: {
        btnBill: '',
        cashBackDescription: '',
        linkCashback: '',
        linkCashbackControl: '',
        linkCashbackZero: '',
        linkShow: '',
        linkShowBills: '',
        notificationBlock: '',
        notificationCreditLimit: '',
        notificationGreat: '',
        notificationPayDate: '',
        notificationUnpaidBills: '',
        on: '',
        promisedPayment: {
            buttonLabel: '',
            title: '',
        },
        till: '',
        titleCashback: '',
        titleCreditLimit: '',
        titleCurrentBalance: '',
        titleTotalBalance: '',
        unpaidBillsQuantity: ['', '', ''],
        hasNewBillsText: '',
    },
    title: '',
};

export default initTranslationWidgetPersonalAccount;
